import * as React from 'react';
import classNames from 'classnames';
import spriteUrl from 'assets/sprite/icons.svg';

export interface IconProps {
  name: string;
  className?: string;
}

export const Icon: React.VFC<IconProps> = ({ name, className }) => {
  return (
    <svg className={classNames('o-icon', className)}>
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`${spriteUrl}#icon-${name}`} />
    </svg>
  );
};

export default Icon;
